module.exports = __webpack_public_path__ + "assets/bg.0d36533c.png";